<template>
  <Breadcrumbs
      title="Distributor Vehicles"
      :breadcrumbs="[
      { label: 'Master Data', path: '' },
      { label: 'Distributor Vehicles', path: '/distributor-vehicles' },
    ]"
  />

  <div class="container-fluid">
    <div class="row project-cards">
      <distributorVehicles/>
    </div>
  </div>
</template>

<script>
import distributorVehicles from './distributor_vehicles_form.vue'
export default {
  name: 'vehicleIndexList',
  components: {
    distributorVehicles,
  },
}
</script>